'use strict';
import isObject from 'lodash/isObject';


ModelStateCache.$inject = [
  '$exceptionHandler',
  '$cacheFactory',
  'FirebaseUtil',
  'OrganizationDomain',
  'ProjectDomain',
  'AssetDomain',
  'AssetProjectDomain',
];

export function ModelStateCache(
  $exceptionHandler,
  $cacheFactory,
  FirebaseUtil,
  OrganizationDomain,
  ProjectDomain,
  AssetDomain,
  AssetProjectDomain,
) {
  const localCache = $cacheFactory('_model-state-cache-local');
  const cacheCollection = '_model-state-cache';

  this.getState = getState;

  function getState(uri) {
    const cached = localCache.get(uri);
    if (cached) {
      return Promise.resolve(cached);
    } else {
      return FirebaseUtil.read(cacheCollection + '/' + uri)
        .then(state => {
          if (isObject(state)) {
            const unflattenedState = convertToState(state);
            localCache.put(uri, unflattenedState);
            return unflattenedState;
          } else {
            return null;
          }
        })
        .catch(e => {
          $exceptionHandler(e, 'Failed to retrieve app state');
        });
    }
  }

  function convertToState(flatState) {
    const result = {};
    if (flatState.organization) {
      result.organization = {
        id: flatState.organization,
        collection: OrganizationDomain.COLLECTION,
      };
    }
    if (flatState.project) {
      result.project = {
        id: flatState.project,
        collection: ProjectDomain.COLLECTION,
      };
    }
    if (flatState.asset) {
      result.asset = {
        id: flatState.asset,
        collection: AssetDomain.COLLECTION,
      };
    }
    if (flatState.assetProject) {
      result.assetProject = {
        id: flatState.assetProject,
        collection: AssetProjectDomain.COLLECTION,
      };
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/js/app-model/ModelStateCache.js